import articlesDashboardAdmin from "./articlesDashboardAdmin"
export default articlesDashboardAdmin;
